import React from 'react';
// import PropTypes from 'prop-types';

export default class ProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.lineHeight = this.props.lineHeight || 54;
    this.height = 0; // ((parseInt(this.props.stages, 10) * this.lineHeight) + 12) + 'px';
    this.completed = 0; // ((parseInt(this.props.completedStages, 10) * this.lineHeight) + 12) + 'px';
  }
  getColor = (percent) => {
    if (percent === 100) return 'green';
    return percent > 50 ? 'green' : 'green';
  }

  getWidthAsPercentOfTotalWidth = () => parseInt(this.props.width * (this.props.percent / 100), 10)

  createDotesForWap = () => {
    const stagesArray = [];
    let increament = 20;
    // const dotTop = increament;

    if (this.props.stages && this.props.stages > 0) {
      for (let i = 1; i <= this.props.stages; i++) {
        const dotTop = increament;
        stagesArray.push(<span className="myprogressDot" style={{ top: dotTop + 'px' }} />);
        increament += this.lineHeight; // (204 / this.props.stages);
      }
    }
    return stagesArray;
  }

  renderWEB() {
    const { height } = this.props;
    return (
      <div className="progress-bar" style={{ width: this.getWidthAsPercentOfTotalWidth(), backgroundColor: '#ddd' }}>
        <div
          style={{
            height,
          }}
        />
      </div>
    );
  }

  renderWAP() {
    // const height1 = this.height + ' !important';
    this.height = ((parseInt(this.props.stages, 10) * this.lineHeight) + 12) + 'px';
    this.completed = ((parseInt(this.props.completedStages, 10) * this.lineHeight) + 12) + 'px';
    return (
      <React.Fragment>
        <div className="progress vertical progressBar" style={{ left: '18px', height: this.height }}>
          <div className="progress-bar progress-bar-info" style={{ width: '25px', backgroundColor: '#ddd', height: this.completed }}>
            <div
              style={{
                height: this.completed,
              }}
            />
          </div>
        </div>
        {this.createDotesForWap()}
      </React.Fragment>
    );
  }

  render() {
    if (this.props.channel === 'wap') {
      return this.renderWAP();
    }
    return this.renderWEB();
  }
}

ProgressBar.defaultProps = {
  height: 5,
};
